import { paqImages } from '../constants/paqueterias';

export const getPaqueteriaImg = (name) => {
  const paq = name.toLowerCase().trim();

  const obj = paqImages.find((item) => item?.id === paq);

  return obj?.img;
};
